/*
 *   Copyright (c) 2021 Sok Channy
 *   All rights reserved.
 */
// Copyright 2021 channysok

import React, {useEffect, useState, useCallback} from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faEdit, faSearch, faUser } from "@fortawesome/free-solid-svg-icons"
import { Badge, Breadcrumb, Button, Card, Col, ProgressBar, Row, Table, Dropdown, ButtonGroup, Form, InputGroup } from '@themesberg/react-bootstrap'
import { useDispatch, useSelector } from "react-redux"
import UserAction from "../../core/redux/action/UserAction"
import _, { last } from "lodash"
import PuPagination from "../../components/PuPagination"
import NewSystemUserPage from "./NewSystemUserPage"
import SystemUserDetailPage from "./SystemUserDetailPage"
import AppConfig from "../../core/config/AppConfig"

export default (props) => {

    const dispatch = useDispatch();
    
    const userRes = useSelector((state) => state.user);
    //const receivers = _.get(userRes, "userList.data");
    const pages = _.get(userRes, "userList.pages");
    const size = _.get(userRes, "userList.size");
    const total = _.get(userRes, "userList.total");
    const [currentPage, setCurrentPage] = useState()

    const [role, setRole] = useState()
    const [active, setActive] = useState()
    const [phone, setPhone] = useState()
    const [lastName, setLastName] = useState()
    const [firstName, setFirstName] = useState()

    // const [receiverId, setReceiverId] = useState('ff8080817a3704b5017a370579fe0000');
    const [userId, setUserId] = useState();
    const [isCreate, setIsCreate] = useState();

    const keyPressFunction = useCallback((event) => {
        if(event.keyCode === 13) {
          fetchData()
        }
      }, [props, firstName, lastName, active, role]);
    
      useEffect(() => {
        document.addEventListener("keydown", keyPressFunction, false);
    
        return () => {
          document.removeEventListener("keydown", keyPressFunction, false);
        };
      }, [keyPressFunction]);

    useEffect(() => {
        if(_.get(userRes, "userList.data") == undefined){
          fetchData()
        }       
      }, [])

    useEffect(() => {      
        fetchData()      
    }, [currentPage])

    
    const fetchData = () => {
        dispatch(UserAction.getUserList({
            "input": {
                role
              , phone
              , firstName
              , lastName 
              , active            
            },
            "token": "string"
        },{
            size: AppConfig.pageSize,
            sort: "createdAt,DESC",
            page: currentPage
        }));
    }


    if(isCreate) {
        return <NewSystemUserPage onClose={(timer)=>{
                setIsCreate(undefined)
                clearInterval(timer)
            }} />
    }

    if(userId) {
        return <SystemUserDetailPage 
            id={userId}
            onClose={(timer)=>{
                setUserId(undefined)
                clearInterval(timer)
            }}
        />
    }

    return (
        <>
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center">
                <div className="d-block mb-4 mb-md-0">                
                <h4>System User</h4>
                <p className="mb-0"> </p>
                </div>
                <div className="btn-toolbar mb-2 mb-md-0">
                <ButtonGroup>
                    <Button variant="outline-primary" size="sm" onClick={()=>setIsCreate(true)}>New</Button>
                    <Button variant="outline-primary" size="sm">Export</Button>
                </ButtonGroup>
                </div>
            </div>
            
            <Card border="light" className="shadow-sm mb-4">
            <Card.Body className="pb-0">

                <Row>                    
                    <Col xs={12} sm={6} xl={2}>
                        <Form.Group className="mb-3">
                            <Form.Label>Role</Form.Label>
                            <InputGroup>
                                <Form.Select 
                                    onChange={(e) => {                                                                                                
                                        setRole(e.target.value ==  e.target.value == "--Select--" ? undefined : e.target.value)
                                    }}                                                
                                >                                            
                                <option>--Select--</option>
                                <option>Admin</option>
                                <option>Super Admin</option>
                                </Form.Select>                
                            </InputGroup>
                        </Form.Group> 
                    </Col>
                    <Col xs={12} sm={6} xl={2}>
                        <Form.Group className="mb-4">
                        <Form.Label >First Name</Form.Label>
                        <InputGroup>
                            <InputGroup.Text>
                            <FontAwesomeIcon icon={faUser} />
                            </InputGroup.Text>
                            <Form.Control required type="text" placeholder="First Name" 
                            onChange={(e)=>setFirstName(e.target.value == '' ? undefined : e.target.value)}/>
                        </InputGroup>
                        </Form.Group>
                    </Col>
                    <Col xs={12} sm={6} xl={2}>
                        <Form.Group className="mb-4">
                        <Form.Label>Last Name</Form.Label>
                        <InputGroup>
                            <InputGroup.Text>
                            <FontAwesomeIcon icon={faUser} />
                            </InputGroup.Text>
                            <Form.Control required type="text" placeholder="Last name" 
                            onChange={(e)=>setLastName(e.target.value == '' ? undefined : e.target.value)}/>
                        </InputGroup>
                        </Form.Group>
                    </Col>
                    <Col xs={12} sm={6} xl={6}>
                        <Form.Group className="mb-4 float-end" style={{paddingTop: 30}}>
                            <Button onClick={fetchData}><FontAwesomeIcon icon={faSearch} /> Search</Button>
                        </Form.Group>.
                    </Col>
                </Row>

                <Table responsive className="table-centered table-nowrap rounded mb-0">
                <thead className="thead-light">
                    <tr>
                    <th className="border-0">#</th>                    
                    <th className="border-0">Action</th>
                    <th className="border-0">Name</th>                    
                    <th className="border-0">User Name</th>                    
                    <th className="border-0">Role</th> 
                    <th className="border-0">Active</th>
                    </tr>
                </thead>
                <tbody>
                {
                    //receivers && receivers.map()
                    _.get(userRes, 'userList.data') && _.get(userRes, 'userList.data').map((item, index) => {
                        console.log(">>item", item)
                        return (
                            <tr>
                                <td>{(index + 1) + (AppConfig.pageSize * (currentPage ?? 0))}</td>
                                <td>
                                <Button variant="transparent" size="sm" className="ms-3 mb-0 fs-10" onClick={()=>setUserId(item.id)}><FontAwesomeIcon icon={faEdit}/> Edit</Button>
                                </td>
                                <td>{_.get(item, 'firstName', '')} {_.get(item, 'lastName', '')}</td>
                                <td>{_.get(item, 'username', '')}</td>                                
                                <td>{_.get(item, 'role', '')}</td>
                                <td>{_.get(item, 'active') ? 
                                <Badge pill bg='success' className="badge-sm ms-3 mb-0 fs-10">Yes</Badge> :
                                <Badge pill bg='danger' className="badge-sm ms-3 mb-0 fs-10">No</Badge>
                                }</td>
                            </tr>
                        )
                    })
                }                    
                </tbody>
                </Table>
            </Card.Body>
            <Card.Footer>            
              <PuPagination size={size} total={total} currentPage={currentPage} totalPage={pages} onChange={setCurrentPage}/>
            </Card.Footer>
            </Card>
        </>
    )
}

const ReceiverTable = () => {
        
    //const TableRow = (props) => {const { id, source, sourceIcon, sourceIconColor, sourceType, category, rank, trafficShare, change } = props;
  
     
    
}